
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSuccessIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  viewBox: "0 0 80 80",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.44 42.26c1.605-2.1 4.299-3.456 6.861-3.456h9.815l-3.374-10.097a.99.99 0 0 1-.035-.139c-1.393-7.676 1.357-11.402 4.396-12.33 2.401-.733 4.879.276 5.762 2.349l7.343 17.228 7.899 5.038c.485-1.852 2.159-3.22 4.144-3.22h7.462c2.364 0 4.287 1.94 4.287 4.327v27.706c0 2.386-1.923 4.327-4.287 4.327h-7.462c-1.5 0-2.822-.782-3.588-1.963-1.964 1.813-5.79 1.97-8.927 1.97-.337 0-.667-.002-.985-.004l-.815-.003h-17.07c-2.13 0-3.951-.913-5.412-2.713-1.154-1.423-2.06-3.381-2.692-5.822l-4.565-17.614c-.494-1.907-.053-3.89 1.243-5.584Zm40.497 27.406c0 1.288 1.038 2.336 2.314 2.336h7.462c1.276 0 2.314-1.048 2.314-2.336V41.96c0-1.288-1.038-2.337-2.314-2.337h-7.462c-1.276 0-2.314 1.048-2.314 2.337v27.706ZM14.106 47.34l4.564 17.614c.833 3.215 2.584 7.048 6.195 7.048h17.07l.826.003c2.826.016 7.097.039 8.64-1.51.384-.386.563-.843.563-1.439V43.118l-9.068-5.784a.993.993 0 0 1-.38-.448l-7.463-17.513c-.478-1.122-1.962-1.662-3.38-1.229-2.214.676-4.17 3.657-3.039 9.995l3.79 11.343c.102.304.052.638-.133.899a.983.983 0 0 1-.801.415H20.3c-1.943 0-4.073 1.078-5.3 2.682-.646.844-1.326 2.2-.895 3.861Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M44 14.5 49.5 9M16 9l5.5 5.5M32.89 3v7.778",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 2,
  strokeLinecap: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"80\" height=\"80\" viewBox=\"0 0 80 80\" fill=\"none\">\r\n  <path d=\"M13.4395 42.2605C15.0452 40.1609 17.7386 38.8044 20.301 38.8044H30.1162L26.7423 28.7068C26.7271 28.6615 26.7152 28.6151 26.7067 28.5681C25.3139 20.8921 28.0643 17.1657 31.1027 16.238C33.5041 15.5047 35.982 16.5142 36.8653 18.5865L44.2082 35.8154L52.1066 40.8532C52.5923 39.0015 54.2659 37.6325 56.2508 37.6325H63.7131C66.0769 37.6325 68 39.5737 68 41.9599V69.6658C68 72.052 66.0769 73.9933 63.7131 73.9933H56.251C54.7508 73.9933 53.429 73.2108 52.6628 72.0295C50.6987 73.8427 46.8722 74 43.7363 73.9999C43.3989 73.9999 43.069 73.9981 42.7509 73.9964C42.4674 73.9948 42.1945 73.9934 41.9356 73.9934H24.8654C22.7359 73.9934 20.915 73.0803 19.4537 71.2795C18.2997 69.8573 17.3939 67.8989 16.7615 65.4584L12.1973 47.8436C11.7032 45.9367 12.1443 43.954 13.4395 42.2605ZM53.9367 69.6658C53.9367 70.9541 54.9748 72.002 56.251 72.002H63.7131C64.9893 72.002 66.0274 70.9541 66.0274 69.6658V41.9597C66.0274 40.6716 64.9893 39.6235 63.7131 39.6235H56.251C54.9748 39.6235 53.9367 40.6714 53.9367 41.9597V69.6658ZM14.1057 47.3395L18.6699 64.9543C19.503 68.1693 21.2541 72.0019 24.8654 72.0019H41.9355C42.198 72.0019 42.4743 72.0033 42.7615 72.0048C45.5867 72.0211 49.8583 72.0438 51.4008 70.4952C51.7851 70.1094 51.964 69.6524 51.964 69.0565V43.1175L42.896 37.3339C42.7278 37.2265 42.5955 37.0703 42.5169 36.8856L35.0534 19.3734C34.5751 18.2514 33.0907 17.7112 31.6739 18.144C29.459 18.8203 27.5026 21.8014 28.6344 28.1392L32.4244 39.4819C32.526 39.7857 32.4764 40.1204 32.291 40.3808C32.1057 40.6413 31.8075 40.7958 31.4899 40.7958H20.301C18.3576 40.7958 16.2277 41.8736 15.0009 43.4776C14.3549 44.3221 13.6751 45.6778 14.1057 47.3395Z\" fill=\"#000000\"/>\r\n  <path d=\"M44 14.5L49.5 9\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\" stroke-linecap=\"round\"/>\r\n  <path d=\"M16 9L21.5 14.5\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\" stroke-linecap=\"round\"/>\r\n  <path d=\"M32.8891 2.99995V10.7781\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"2\" stroke-linecap=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/SuccessIcon.85d77d3d2d86156724cfef8a144a1cbf.svg"),
        {
          React: SvgSuccessIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      